import React from 'react';
import { Button, Card } from '@openedx/paragon';
import { injectIntl, intlShape } from '@edx/frontend-platform/i18n';

import { useSelector } from 'react-redux';
import { sendTrackingLogEvent } from '@edx/frontend-platform/analytics';
import messages from '../messages';
import { useModel } from '../../../generic/model-store';

function StartOrResumeCourseCard({ intl, courseName, lastVisitedSection, lastVisitedSequence }) {
  const {
    courseId,
  } = useSelector(state => state.courseHome);

  const { org } = useModel('courseHomeMeta', courseId);

  const eventProperties = {
    org_key: org,
    courserun_key: courseId,
  };

  const {
    resumeCourse: {
      hasVisitedCourse,
      url: resumeCourseUrl,
    },
  } = useModel('outline', courseId);

  if (!resumeCourseUrl) {
    return null;
  }

  const logResumeCourseClick = () => {
    sendTrackingLogEvent('edx.course.home.resume_course.clicked', {
      ...eventProperties,
      event_type: hasVisitedCourse ? 'resume' : 'start',
      url: resumeCourseUrl,
    });
  };

  return (
    <Card data-testid="start-resume-card">
      <Card.Header
        title={
          <h2>
            {hasVisitedCourse
              ? intl.formatMessage(messages.resumeBlurb)
              : intl.formatMessage(messages.startBlurb)}
          </h2>
        }
        subtitle={
          lastVisitedSection && lastVisitedSequence
            ? `${courseName} - ${lastVisitedSection.title} - ${lastVisitedSequence.title}`
            : courseName
        }
        actions={
          <Button
            className="start-resume-button"
            variant="primary"
            block
            href={resumeCourseUrl}
            onClick={() => logResumeCourseClick()}
            aria-label={
              lastVisitedSection && lastVisitedSequence
                ? `${intl.formatMessage(messages.resume)} ${courseName}, ${
                    lastVisitedSection.title
                  }, ${lastVisitedSequence.title}`
                : `${intl.formatMessage(messages.start)} ${courseName}`
            }
          >
            {hasVisitedCourse
              ? intl.formatMessage(messages.resume)
              : intl.formatMessage(messages.start)}
          </Button>
        }
      />
      {/* Footer is needed for internal vertical spacing to work out. If you can remove, be my guest */}
      <Card.Footer>
        <></>
      </Card.Footer>
    </Card>
  );
}

StartOrResumeCourseCard.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(StartOrResumeCourseCard);
